export const ACCESS_TOKEN_KEY = 'okta-token-storage';
export const AUTH_STATE_KEY = 'auth';
export const X_IBM_CLIENT_ID = 'X-IBM-Client-Id';
export const X_LABCORP_CLAIMS = 'x-labcorp-claims';
